import React from "react";
import { BrowserRouter as Router, Routes, Route, useRoutes } from "react-router-dom";

import Home from './pages/home.js';
// import Dashboardold from './pages/dashboardold.js';
import Dashboard from "./pages/dashboard.js";
import JoinNow from './pages/join-now';
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Terms from "./pages/terms.js";
import Staking from "./pages/staking.js";
import { WagmiConfig, createConfig, configureChains, mainnet } from 'wagmi'
import { publicProvider } from 'wagmi/providers/public'
import { InjectedConnector } from 'wagmi/connectors/injected'
import { MetaMaskConnector } from 'wagmi/connectors/metaMask'
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect'
import { polygon, polygonMumbai } from "wagmi/chains";
import { Provider } from "react-redux";
import store from './store'
import config from "./config/config";

const { chains, publicClient, webSocketPublicClient } = configureChains(
  [polygon, polygonMumbai],
  [publicProvider()],
)
console.log(config.projectId, 'config.projectId')
const wconfigInitial = createConfig({
  autoConnect: true,
  connectors: [
    new MetaMaskConnector({ chains }),
    new WalletConnectConnector({
      chains,
      options: {
        projectId: config.projectId,
        version: 2
      },
    })
  ],
  publicClient,
  webSocketPublicClient,
});

const App = () => {
  const routes = useRoutes([
    { path: "/", element: <Home /> },
    // { path: "dashboardold", element: <Dashboardold /> },
    { path: "dashboard", element: <Dashboard /> },
    { path: "join-now", element: <JoinNow /> },
    { path: "join-now/:id", element: <JoinNow /> },
    { path: "terms", element: <Terms /> },
    { path: "staking", element: <Staking /> }
  ]);
  return routes;
};

const AppWrapper = () => {
  return (
    <Provider store={store}>
      <Router basename="/">
        <ToastContainer />
        <WagmiConfig config={wconfigInitial}>
          <App />
        </WagmiConfig>
      </Router>
    </Provider>
  );
};

export default AppWrapper;